export enum UiControlType {
  Dropdown = 'dropdown',
  Text = 'text',
  Checkbox = 'checkbox',
  Radio = 'radio',
  Number = 'number',
  Label = 'label',
  DynamicList = 'dynamicList',
  DynamicDict = 'dynamicDict',
  CSV = 'csv',
  TextArea = 'textarea',
  BooleanDropdown = 'booleanDropdown',
  External = 'external',
  DragDrop = 'dragdrop',
  CSVUtils = 'csvUtils',
  Date = 'date',
  Chips = 'chips',
}
